var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import InfoPopUp from '@web/components/layout/InfoPopUp';
import { buildDiffTooltipText } from '@web/utility/diffTooltip';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';
export var useDiffTooltip = function (diffValue, options) {
    var t = useTranslation().t;
    var tooltipId = useId().replace(/:/g, '');
    var tooltipText = buildDiffTooltipText(diffValue, t, options);
    return { tooltipText: tooltipText, tooltipId: tooltipId };
};
export var DiffTooltip = function (_a) {
    var text = _a.text, id = _a.id, children = _a.children;
    if (!text) {
        return _jsx(_Fragment, { children: children });
    }
    return (_jsx(InfoPopUp, __assign({ text: text, classes: "", tooltipClasses: "max-w-[350px] z-50 !text-sm !font-normal", id: id, place: "top", noMargin: true, flexTrigger: true }, { children: children })));
};
